import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import tagsActions from '../../tags/action-creators';
import notificationsActions from '../../notifications/action-creators';
import taskGroupsCommitTypes from '../commit-types';

const taskGroupsActions = {
  activateTaskGroup(taskGroupGuid, attach) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('activateTaskGroup'));
      const data = await ApiService.post(`/api/v1/task-groups/${taskGroupGuid}/activate`, {attach: attach})
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('activateTaskGroup'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.activateTaskGroupSuccess(data));
      }
      return Promise.resolve();
    };
  },
  activateTaskGroupSuccess(taskGroupsResponse) {
    return (dispatch) => {
      dispatch(this.replaceTaskGroup(taskGroupsResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Group activated'));
    };
  },
  addTaskGroup() {
    return {
      isAddingTaskGroup: true,
      type: taskGroupsCommitTypes.SET_IS_ADDING_TASK_GROUP,
    };
  },
  archiveTaskGroup(taskGroupGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('archiveTaskGroup'));
      const data = await ApiService.post(`/api/v1/task-groups/${taskGroupGuid}/archive`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('archiveTaskGroup'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.archiveTaskGroupSuccess(data));
      }
      return Promise.resolve();
    };
  },
  archiveTaskGroupSuccess(taskGroupsResponse) {
    return (dispatch) => {
      dispatch(this.replaceTaskGroup(taskGroupsResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Group archived'));
    };
  },
  closeAddTaskGroup() {
    return {
      isAddingTaskGroup: false,
      type: taskGroupsCommitTypes.SET_IS_ADDING_TASK_GROUP,
    };
  },
  cloneTaskGroup(formData) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('cloneTaskGroup'));
      const data = await ApiService.post('/api/v1/task-groups', formData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('cloneTaskGroup'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.cloneTaskGroupSuccess(data));
      }
    };
  },
  cloneTaskGroupSuccess(taskGroupsResponse) {
    return (dispatch) => {
      dispatch(this.pushTaskGroup(taskGroupsResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Group cloned'));
    };
  },
  createTaskGroup(taskGroup) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('createTaskGroup'));
      const data = await ApiService.post('/api/v1/task-groups', taskGroup)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('createTaskGroup'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.createTaskGroupSuccess(data));
      }
    };
  },
  createTaskGroupSuccess(taskGroupsResponse) {
    return (dispatch) => {
      dispatch(this.pushTaskGroup(taskGroupsResponse.data));
      dispatch(this.closeAddTaskGroup());
      dispatch(notificationsActions.addSavedSuccessfully('Task Group created'));
    };
  },
  deleteTaskGroup(taskGroupGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('deleteTaskGroup'));
      const data = await ApiService.delete(`/api/v1/task-groups/${taskGroupGuid}`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('deleteTaskGroup'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.deleteTaskGroupSuccess(data));
      }
    };
  },
  deleteTaskGroupSuccess(deletedResponse) {
    return (dispatch) => {
      dispatch(this.removeTaskGroup(deletedResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Group draft deleted'));
    };
  },
  fetchTaskGroups() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchTaskGroups'));
      const data = await ApiService.get('/api/v1/task-groups')
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('fetchTaskGroups'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.fetchTaskGroupsSuccess(data));
        dispatch(this.generateTaskGroupMap(data));
        dispatch(this.setTaskGroupMap(data));
      }
    };
  },
  fetchTaskGroupsSuccess(taskGroupsResponse) {
    return (dispatch) => {
      dispatch(this.pushTaskGroups(taskGroupsResponse.data));
    };
  },

  setTaskGroupMap(taskGroups) {
    let tasksGroupMap = taskGroups.data.reduce((acc, taskGroup) => {
      if(taskGroup.parent_guid) {
        let parentGroup = acc[taskGroup.parent_guid] || {};
        let subGroups = parentGroup.subGroups || [];
        return {
          ...acc,
          [taskGroup.parent_guid]: {
            ...parentGroup,
            subGroups: [...subGroups, taskGroup]
          }
        }
      } else {
        let parentGroup = acc[taskGroup.taskGroupGuid] || {};
        return {
          ...acc,
          [taskGroup.taskGroupGuid]: {
            ...parentGroup,
            ...taskGroup
          }
        }
      }
    }, {})

    return {
      tasksGroupMap,
      type: taskGroupsCommitTypes.SET_TASK_GROUP_MAP2,
    }
  },

  generateTaskGroupMap(taskGroups) {
    let tasksMap = {};

    taskGroups.data.reduce(function (acc, taskGroup) {
      taskGroup.tasks.reduce(function (acc, task) {
        tasksMap[task.taskGuid] = {
          taskGroupDescription: taskGroup.description,
          taskGroupName : taskGroup.name
        }

        return acc;
      }, []);

      return acc;
    }, []);

    return {
      tasksMap,
      type: taskGroupsCommitTypes.SET_TASK_GROUP_MAP,
    };
  },
  loadTaskGroupContainer() {
    return (dispatch) => {
      dispatch(this.fetchTaskGroups());
      dispatch(tagsActions.fetchTags());
    };
  },
  pushTaskGroup(taskGroup) {
    return {
      taskGroup,
      type: taskGroupsCommitTypes.PUSH_TASK_GROUP,
    };
  },
  pushTaskGroups(taskGroups) {
    return {
      taskGroups,
      type: taskGroupsCommitTypes.PUSH_TASK_GROUPS,
    };
  },
  removeTaskGroup(deleted) {
    return {
      taskGroupGuid: deleted.guid,
      type: taskGroupsCommitTypes.REMOVE_TASK_GROUP,
    };
  },
  replaceTaskGroup(taskGroup) {
    return {
      taskGroup,
      type: taskGroupsCommitTypes.REPLACE_TASK_GROUP,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: taskGroupsCommitTypes.SET_TASK_GROUPS_IS_LOADING,
    };
  },
  setSelectedTaskGroup(selectedGuid) {
    return {
      selectedGuid,
      type: taskGroupsCommitTypes.SET_SELECTED_TASK_GROUP_GUID,
    };
  },
  unmountTaskGroupContainer() {
    return {
      type: taskGroupsCommitTypes.RESET_TASK_GROUP_STATE,
    };
  },
  updateTaskGroup(formData) {
    return async (dispatch) => {
      const patch = { ...formData };
      // Remove redundant
      delete patch.taskGroupGuid;
      dispatch(this.setIsLoading('updateTaskGroup'));
      const data = await ApiService.patch(
        `/api/v1/task-groups/${formData.taskGroupGuid}`,
        patch,
      )
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateTaskGroup'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateTaskGroupSuccess(data));
      }
      return Promise.resolve();
    };
  },
  updateTaskGroupSuccess(taskGroupsResponse) {
    return (dispatch) => {
      dispatch(this.replaceTaskGroup(taskGroupsResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Group updated'));
    };
  },
};

export default taskGroupsActions;
